// Base Client
import { dateToInt64UTC, getApiToken } from "../helpers";
import { getBffRequest } from "./base/api";

// Protos
import { ClaimsBFFControllerClient } from "./protos/Claims-bffServiceClientPb";
import {
	GetPolicyIdByMemberIdRequest,
	GetPolicyIdByMemberIdResponse,
	HasPolicyByMemberIdRequest,
	HasPolicyByMemberIdResponse
} from "./protos/messages/members.message_pb";

export const getPolicyIdByMemberId = async (
	memberId: number,
	dateOfInitialConsultation: Date,
	finalDateOfService: Date,
	caseId?: number
): Promise<GetPolicyIdByMemberIdResponse> => {
	const token: string = getApiToken();

	const request: GetPolicyIdByMemberIdRequest = new GetPolicyIdByMemberIdRequest();
	request.setMemberId(memberId);
	request.setDateOfInitialConsultation(dateToInt64UTC(dateOfInitialConsultation));
	request.setFinalDateOfService(dateToInt64UTC(finalDateOfService));
	if (caseId) request.setCaseId(caseId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	try {
		return await client.getPolicyIdByMemberId(request, {});
	} catch (err) {
		console.error(err);
		throw err;
	}
};

export const hasPolicyByMemberId = async (memberId: number): Promise<HasPolicyByMemberIdResponse> => {
	const token: string = getApiToken();

	const request: HasPolicyByMemberIdRequest = new HasPolicyByMemberIdRequest();
	request.setMemberId(memberId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.hasPolicyByMemberId(request, {})
		.then((response: HasPolicyByMemberIdResponse) => response)
		.catch((err) => {
			console.error(err);
			throw err;
		});
};
